<script setup>
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';
import Modal from '../../../../components/Modal.vue';
import MessageTemplateForm from './MessageTemplateForm.vue';
import { default as FluentIcon } from 'shared/components/FluentIcon/Icon.vue';
import dashboardIcons from 'shared/components/FluentIcon/dashboard-icons.json';
import Button from 'dashboard/components-next/button/Button.vue';

const emit = defineEmits(['switch-view', 'template-created']);
const { t } = useI18n();
const showNewTemplateModal = ref(false);

const handleBack = () => {
  emit('switch-view', 'pipeline');
};

const handleTemplateCreated = template => {
  showNewTemplateModal.value = false;
  emit('template-created', template);
};
</script>

<template>
  <header
    class="px-6 py-4 border-b border-slate-200 bg-white dark:border-slate-800 dark:bg-slate-900"
  >
    <div class="flex items-center justify-between">
      <div class="flex items-center gap-4">
        <button
          class="p-2 rounded-full hover:bg-slate-100 dark:hover:bg-slate-800 text-slate-700 dark:text-slate-300 transition-colors"
          @click="handleBack"
        >
          <FluentIcon
            icon="arrow-chevron-left"
            size="16"
            :icons="dashboardIcons"
          />
        </button>
        <h1 class="text-2xl font-medium dark:text-slate-100">
          {{ t('PIPELINE.MESSAGE_TEMPLATES.TITLE') }}
        </h1>
      </div>
      <Button
        variant="solid"
        color="blue"
        size="sm"
        @click="showNewTemplateModal = true"
      >
        <template #icon>
          <FluentIcon icon="add" size="20" :icons="dashboardIcons" />
        </template>
        <span>{{ t('PIPELINE.MESSAGE_TEMPLATES.ADD') }}</span>
      </Button>
    </div>

    <Modal
      v-model:show="showNewTemplateModal"
      class="template-modal"
      @close="() => (showNewTemplateModal = false)"
    >
      <div class="p-6">
        <h3 class="text-lg font-medium mb-4 dark:text-slate-100">
          {{ t('PIPELINE.MESSAGE_TEMPLATES.NEW') }}
        </h3>
        <MessageTemplateForm
          @saved="handleTemplateCreated"
          @close="showNewTemplateModal = false"
        />
      </div>
    </Modal>
  </header>
</template>

<style scoped>
:deep(.template-modal .modal-container) {
  max-width: 1024px;
  width: 90vw;
}

:deep(.dark .template-modal .modal-container) {
  background-color: rgb(15 23 42);
}
</style>
